import { render, staticRenderFns } from "./changePSW.vue?vue&type=template&id=c17a9d06&scoped=true&"
import script from "./changePSW.vue?vue&type=script&lang=js&"
export * from "./changePSW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17a9d06",
  null
  
)

component.options.__file = "changePSW.vue"
export default component.exports